var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 37,
    viewBox: "0 0 213 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.384521,
    y: 0.105469,
    width: 36,
    height: 36,
    fill: "#29DA95"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.3845,
    y: 0.105469,
    width: 36,
    height: 36,
    fill: "#29DA95"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.3845,
    y: 0.105469,
    width: 36,
    height: 36,
    fill: "#29DA95"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 132.385,
    y: 0.105469,
    width: 36,
    height: 36,
    fill: "#29DA95"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 176.385,
    y: 0.105469,
    width: 36,
    height: 36,
    fill: "#C2C9C6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 176.385,
    y: 0.105469,
    width: 17.9771,
    height: 36,
    fill: "#29DA95"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6115 22.7748L25.8015 29.5168L18.3885 24.1288L23.6115 22.7748ZM30.3845 15.4148H21.2195L18.3895 6.69385L15.5495 15.4168L6.38452 15.4048L13.8065 20.8018L10.9665 29.5158L18.3885 24.1288L22.9715 20.8018L30.3845 15.4148Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6115 22.7748L69.8015 29.5168L62.3885 24.1288L67.6115 22.7748ZM74.3845 15.4148H65.2195L62.3895 6.69385L59.5495 15.4168L50.3845 15.4048L57.8065 20.8018L54.9665 29.5158L62.3885 24.1288L66.9715 20.8018L74.3845 15.4148Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.612 22.7748L113.802 29.5168L106.389 24.1288L111.612 22.7748ZM118.385 15.4148H109.22L106.39 6.69385L103.55 15.4168L94.3845 15.4048L101.807 20.8018L98.9665 29.5158L106.389 24.1288L110.972 20.8018L118.385 15.4148Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.612 22.7748L157.802 29.5168L150.389 24.1288L155.612 22.7748ZM162.385 15.4148H153.22L150.39 6.69385L147.55 15.4168L138.385 15.4048L145.807 20.8018L142.967 29.5158L150.389 24.1288L154.972 20.8018L162.385 15.4148Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.612 22.7748L201.802 29.5168L194.389 24.1288L199.612 22.7748ZM206.385 15.4148H197.22L194.39 6.69385L191.55 15.4168L182.385 15.4048L189.807 20.8018L186.967 29.5158L194.389 24.1288L198.972 20.8018L206.385 15.4148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.ded3412a7404294822d98476b0486e2c.svg";
export { ForwardRef as ReactComponent };